import jwtDecode from "jwt-decode";
import http from "./httpService";
import config from "../config.json";
import axios from "axios";
import { logCustomEvent } from "./analytics";
const tokenRenewal = axios.create();
tokenRenewal.defaults.baseURL = config.apiUrl;

const tokenKey = "token";

function getCurrentUser() {
  try {
    const jwt =
      localStorage.getItem(tokenKey) ||
      sessionStorage.getItem(tokenKey) ||
      sessionStorage.getItem("visitorToken");
    // if (jwt === null || jwt === undefined) return null
    const jwtDecoded = jwtDecode(jwt);
    const currDate = new Date().getTime() / 1000;
    if (jwtDecoded.exp < currDate) {
      localStorage.clear();
      sessionStorage.clear();
      return null;
    }
    return jwtDecoded;
  } catch (ex) {
    // localStorage.clear()
    return null;
  }
}

function issueToken() {
  return new Promise((resolve, reject) => {
    try {
      const response = http.post("/token-refresh/", {
        token: localStorage.getItem(tokenKey),
      });
      resolve(response);
    } catch (ex) {
      reject(ex);
    }
  });
}

function IsTokenAboutToExpired() {
  const jwt = getCurrentUser();
  if (jwt === null) return false;

  const exp = jwt.exp;
  const currDate = new Date().getTime() / 1000;

  //Refresh Token if tokenLive remains 30 min only
  if (exp - currDate <= 1200 && exp - currDate >= 0) {
    return true;
  }
  return false;
}

function isTokenExpired() {
  const jwt = getCurrentUser();
  if (!jwt) return true;

  const currDate = new Date().getTime() / 1000;
  const exp = jwt.exp;

  return exp < currDate;
}

async function renewToken(expiredToken) {
  const payload = {
    token: expiredToken,
  };
  try {
    const { data } = await tokenRenewal.post(`/phone/renew_token/`, payload);
    return data.token;
  } catch (ex) {
    return new Error("Token not issued");
  }
}

async function loginViaPhone(otp, push) {
  const { data } = await http.post("/phone/verify_otp/", {
    phone: localStorage.getItem("newPhone") || localStorage.getItem("phone"),
    otp: otp,
    action: "LOGIN",
  });
  localStorage.setItem("token", data.token);
  localStorage.setItem("uuid", data.id);
  localStorage.setItem(
    "full_name",
    data &&
      data.profile &&
      data.profile.first_name + " " + data &&
      data.profile &&
      data.profile.last_name
  );
  localStorage.setItem(
    "first_name",
    (data && data.profile && data.profile.first_name) || ""
  );
  localStorage.setItem(
    "last_name",
    (data && data.profile && data.profile.last_name) || ""
  );
  localStorage.setItem("dob", data && data.profile && data.profile.dob);
  localStorage.setItem("current_city", data.city || "");
  localStorage.setItem("pinCode", data.pincode || "");
  localStorage.setItem("email", data.email || "");
  localStorage.setItem("pre_cutoff_date", data.pre_cutoff_date || "");
  let page;

  if (data.flex_employee) {
    localStorage.setItem("employee_plan_type", "FLEX");
  } else {
    localStorage.setItem("pre_conventional", true);
  }

  if (data.pre_cutoff_date) {
    page = "/flex/dashboard/onboarding";
  } else if (!data.pre_cutoff_date) {
    try {
      let { data } = await http.get("/dashboard/get_bought_policies/");
      if (data.data && data.data.length > 0) {
        page = "/home";
      } else {
        push("/flex/dashboard/completion", {
          message: "The enrolment window has now been closed.",
          title: "Sorry!",
        });
        return;
      }
    } catch (err) {
      if (err && err.response && err.response.data === "no policies") {
        push("/flex/dashboard/completion", {
          message: "The enrolment window has now been closed.",
          title: "Sorry!",
        });
        return;
      }
    }
  }
  push(page);
}

async function loginViaEmployeeId(login_password, push, setErrors, empId = "") {
  try {
    const { data } = await http.post("/phone/verify_employee_login/", {
      employee_id: empId !== "" ? empId : localStorage.getItem("employeeId"),
      password: login_password,
    });

    logCustomEvent("login", data);
    localStorage.setItem("userDetailsForAnalytics", JSON.stringify(data));

    localStorage.setItem("token", data.token);
    localStorage.setItem("uuid", data.id);
    localStorage.setItem(
      "full_name",
      data &&
        data.profile &&
        data.profile.first_name + " " + data &&
        data.profile &&
        data.profile.last_name
    );
    localStorage.setItem(
      "first_name",
      (data && data.profile && data.profile.first_name) || ""
    );
    localStorage.setItem(
      "last_name",
      (data && data.profile && data.profile.last_name) || ""
    );
    localStorage.setItem("dob", data && data.profile && data.profile.dob);
    localStorage.setItem("current_city", data.city || "");
    localStorage.setItem("pinCode", data.pincode || "");
    localStorage.setItem("email", data.email || "");
    localStorage.setItem("gender", data.profile.gender);
    localStorage.setItem("company_pre", data.company || "");
    localStorage.setItem("pre_cutoff_date", data.pre_cutoff_date || "");

    let page;

    // if (!data.is_password_changed && !data.pre_cutoff_date) {
    if (false) {
      page = "/password-reset";
      push(page);
    } else {
      if (data.flex_employee) {
        localStorage.setItem("employee_plan_type", "FLEX");
      } else {
        localStorage.setItem("pre_conventional", true);
      }

      if (data.pre_cutoff_date) {
        page = "/flex/dashboard/onboarding";
      } else if (!data.pre_cutoff_date) {
        try {
          let { data } = await http.get("/dashboard/get_bought_policies/");
          if (data.data && data.data.length > 0) {
            page = "/home";
          } else {
            push("/flex/dashboard/completion", {
              message: "The enrolment window has now been closed.",
              title: "Sorry!",
            });
            return;
          }
        } catch (err) {
          if (err && err.response && err.response.data === "no policies") {
            push("/flex/dashboard/completion", {
              message: "The enrolment window has now been closed.",
              title: "Sorry!",
            });
            return;
          }
        }
      }

      push(page);
    }
  } catch (err) {
    setErrors({ password: err.response.data || "Some error occurred" });
    console.log({ err });
  }
}

export default {
  getCurrentUser,
  issueToken,
  IsTokenAboutToExpired,
  renewToken,
  isTokenExpired,
  loginViaPhone,
  loginViaEmployeeId,
};
